import type { FileRetrieve, FileRevision } from '@openapi'

export function getFileRevisions(payload: {
  id?: FileRetrieve['id']
  file_id?: FileRetrieve['id']
}): Promise<FileRevision[]> {
  const { id, file_id } = payload
  return this.API.request('get_file_revisions', { file_id: id || file_id })
}
